module.exports = __webpack_public_path__ + "static/media/AshevilleBrewingpipemuraldetail1.f3526606.webp";